/* Exokit - Formulaire de candidature partenaire + sticky CTA.
   Toute la configuration vient d'attributs data- poses sur le <form> par la
   section exokit-pro.liquid. Rien a modifier ici : tout se regle dans
   l'editeur de theme.

   Regex volontairement sans antislash pour rester intactes a travers les
   couches d'encodage successives. Ne pas les reecrire en \s, \d, \.
*/
(function(){
'use strict';

var EMAIL_RE = /^[^ @]+@[^ @]+[.][a-z]{2,}$/i;
var ZIP_RE = /^[0-9]{5}$/;

function digits(s){ return (s || '').replace(/[^0-9]/g, ''); }

function cookie(name){
  var parts = ('; ' + document.cookie).split('; ' + name + '=');
  if(parts.length === 2) return parts.pop().split(';').shift();
  return '';
}

function init(){
  var page = document.querySelector('.exo-page');
  if(!page) return;

  /* ---------- Sticky CTA ---------- */
  var sticky = document.getElementById('exo-sticky');
  var hero   = document.getElementById('exo-hero');
  var formS  = document.getElementById('candidature');
  if(sticky && hero && formS && 'IntersectionObserver' in window){
    var heroVisible = true, formVisible = false;
    var refresh = function(){
      if(!heroVisible && !formVisible) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
    };
    new IntersectionObserver(function(e){ heroVisible = e[0].isIntersecting; refresh(); }, {threshold:0.15}).observe(hero);
    new IntersectionObserver(function(e){ formVisible = e[0].isIntersecting; refresh(); }, {threshold:0.05}).observe(formS);
  }

  /* ---------- Formulaire ---------- */
  var old = document.getElementById('exo-form');
  if(!old) return;
  /* Clone : supprime tout ecouteur deja pose, donc jamais de double envoi. */
  var f = old.cloneNode(true);
  old.parentNode.replaceChild(f, old);

  var cfg = {
    webhook:  f.getAttribute('data-webhook') || '',
    portal:   f.getAttribute('data-hs-portal') || '',
    formGuid: f.getAttribute('data-hs-form') || '',
    gads:     f.getAttribute('data-gads') || '',
    map: {
      naf:       f.getAttribute('data-map-naf') || '',
      activite:  f.getAttribute('data-map-activite') || '',
      vehicules: f.getAttribute('data-map-vehicules') || '',
      volume:    f.getAttribute('data-map-volume') || '',
      origine:   f.getAttribute('data-map-origine') || ''
    }
  };

  var success  = document.getElementById('exo-success');
  var alertBox = document.getElementById('exo-alert');
  var submit   = document.getElementById('exo-submit');
  if(!success || !alertBox || !submit) return;

  var submitLabel = submit.textContent;

  function val(id){ var el = document.getElementById(id); return el ? el.value.trim() : ''; }

  function setInvalid(el, bad){
    var g = el.closest('.exo-fgroup');
    if(!g) return;
    if(bad) g.classList.add('is-invalid'); else g.classList.remove('is-invalid');
  }

  function paintChecks(){
    Array.prototype.forEach.call(f.querySelectorAll('.exo-check'), function(l){
      var i = l.querySelector('input');
      if(i && i.checked) l.classList.add('is-on'); else l.classList.remove('is-on');
    });
  }

  function validate(){
    var firstBad = null;
    var checks = [
      ['exo-firstname', function(v){ return v.length >= 2; }],
      ['exo-lastname',  function(v){ return v.length >= 2; }],
      ['exo-email',     function(v){ return EMAIL_RE.test(v); }],
      ['exo-phone',     function(v){ var d = digits(v); return d.length >= 9 && d.length <= 15; }],
      ['exo-company',   function(v){ return v.length >= 2; }],
      ['exo-zip',       function(v){ return ZIP_RE.test(v); }],
      ['exo-city',      function(v){ return v.length >= 2; }],
      ['exo-activity',  function(v){ return v !== ''; }],
      ['exo-volume',    function(v){ return v !== ''; }]
    ];
    checks.forEach(function(c){
      var el = document.getElementById(c[0]);
      if(!el) return;
      var ok = c[1](el.value.trim());
      setInvalid(el, !ok);
      if(!ok && !firstBad) firstBad = el;
    });

    var vehGroup = document.getElementById('exo-veh-group');
    if(vehGroup){
      if(f.querySelectorAll('input[name=vehicules]:checked').length > 0){
        vehGroup.classList.remove('is-invalid');
      } else {
        vehGroup.classList.add('is-invalid');
        if(!firstBad) firstBad = vehGroup;
      }
    }

    if(firstBad){
      firstBad.scrollIntoView({behavior:'smooth', block:'center'});
      if(firstBad.focus){ try { firstBad.focus({preventScroll:true}); } catch(e){} }
      return false;
    }
    return true;
  }

  Array.prototype.forEach.call(f.querySelectorAll('.exo-input, .exo-select'), function(el){
    el.addEventListener('input',  function(){ setInvalid(el, false); });
    el.addEventListener('change', function(){ setInvalid(el, false); });
  });
  Array.prototype.forEach.call(f.querySelectorAll('input[name=vehicules]'), function(el){
    el.addEventListener('change', function(){
      paintChecks();
      var g = document.getElementById('exo-veh-group');
      if(g) g.classList.remove('is-invalid');
    });
  });
  paintChecks();

  /* ---------- Envois ---------- */

  function sendMake(data){
    if(!cfg.webhook) return Promise.resolve();
    var body = JSON.stringify(data);
    return fetch(cfg.webhook, {
      method:'POST', headers:{'Content-Type':'application/json'}, body: body
    }).then(function(res){
      if(!res.ok) throw new Error('make ' + res.status);
    }).catch(function(){
      /* Repli sans preflight si le navigateur bloque pour cause de CORS. */
      return fetch(cfg.webhook, {
        method:'POST', mode:'no-cors',
        headers:{'Content-Type':'text/plain;charset=UTF-8'}, body: body
      });
    });
  }

  function hubspotFields(d){
    var out = [];
    function push(name, value){
      if(!name || value === '' || value === null || typeof value === 'undefined') return;
      out.push({objectTypeId:'0-1', name:name, value:String(value)});
    }
    push('firstname', d.prenom);
    push('lastname',  d.nom);
    push('email',     d.email);
    push('phone',     d.telephone);
    push('company',   d.entreprise);
    push('zip',       d.code_postal);
    push('city',      d.ville);

    /* Champs metier : sur une propriete dediee si son nom interne est
       renseigne dans l'editeur, sinon repliees dans le message. */
    var reste = [];
    function metier(mapKey, label, value){
      if(!value) return;
      if(cfg.map[mapKey]) push(cfg.map[mapKey], value);
      else reste.push(label + ' : ' + value);
    }
    metier('activite',  "Type d'activite", d.type_activite);
    metier('naf',       'Code NAF', d.code_naf);
    metier('vehicules', 'Vehicules amenages', d.vehicules_texte);
    metier('volume',    'Volume mensuel estime', d.volume_mensuel);
    metier('origine',   'Connu via', d.connu_via);

    var msg = [];
    if(reste.length) msg.push(reste.join('\n'));
    if(d.message) msg.push('Message : ' + d.message);
    if(msg.length) push('message', msg.join('\n\n'));

    return out;
  }

  function sendHubspot(d){
    if(!cfg.portal || !cfg.formGuid) return Promise.resolve();
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + cfg.portal + '/' + cfg.formGuid;
    var payload = {
      fields: hubspotFields(d),
      context: {
        pageUri: window.location.href,
        pageName: document.title
      }
    };
    var hutk = cookie('hubspotutk');
    if(hutk) payload.context.hutk = hutk;
    return fetch(url, {
      method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload)
    }).then(function(res){
      if(!res.ok) return res.text().then(function(t){ throw new Error('hubspot ' + res.status + ' ' + t); });
    });
  }

  f.addEventListener('submit', function(ev){
    ev.preventDefault();
    alertBox.style.display = 'none';

    var hp = document.getElementById('exo-website');
    if(hp && hp.value !== ''){
      f.style.display = 'none'; success.style.display = 'block'; return;
    }
    if(!validate()) return;

    var vehicules = Array.prototype.map.call(
      f.querySelectorAll('input[name=vehicules]:checked'),
      function(el){ return el.value; }
    );

    var d = {
      type: 'demande_partenariat',
      source_page: 'professionnels',
      url: window.location.href,
      date_envoi: new Date().toISOString(),
      prenom:          val('exo-firstname'),
      nom:             val('exo-lastname'),
      email:           val('exo-email'),
      telephone:       val('exo-phone'),
      entreprise:      val('exo-company'),
      code_postal:     val('exo-zip'),
      ville:           val('exo-city'),
      code_naf:        val('exo-naf'),
      type_activite:   val('exo-activity'),
      vehicules:       vehicules,
      vehicules_texte: vehicules.join(', '),
      volume_mensuel:  val('exo-volume'),
      connu_via:       val('exo-source'),
      message:         val('exo-message')
    };

    submit.classList.add('is-loading');
    submit.textContent = 'Envoi en cours...';

    function showSuccess(){
      if(cfg.gads && typeof window.gtag === 'function'){
        window.gtag('event', 'conversion', {send_to: cfg.gads});
      }
      f.style.display = 'none';
      success.style.display = 'block';
      success.scrollIntoView({behavior:'smooth', block:'center'});
    }
    function showError(err){
      if(window.console && err) window.console.warn('[Exokit] envoi formulaire :', err);
      alertBox.style.display = 'block';
      submit.classList.remove('is-loading');
      submit.textContent = submitLabel;
    }

    /* HubSpot est le systeme de reference : c'est lui qui decide du succes.
       Make part en parallele et n'est jamais bloquant. */
    var makeCall = sendMake(d).catch(function(e){
      if(window.console) window.console.warn('[Exokit] webhook Make :', e);
    });

    if(cfg.portal && cfg.formGuid){
      sendHubspot(d).then(showSuccess).catch(showError);
    } else {
      makeCall.then(showSuccess).catch(showError);
    }
  });
}

if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

})();
